import React, { useState } from 'react';
import { Plus, Edit2, Trash2, FileText, Download, Eye, X, ChevronDown, ChevronUp, Copy, Settings, Sparkles, Library, Check } from 'lucide-react';
import { exportarPDF, exportarWord, htmlProposta } from '../utils/exportDoc';
import { toast } from '../utils/toast';
import { cnpjFormatado } from '../utils/cnpj';

const STATUS_COR = { RASCUNHO: '#5f5874', ENVIADA: '#3b82f6', NEGOCIACAO: '#f59e0b', ACEITA: '#10b981', RECUSADA: '#ef4444' };

export const CATEGORIAS_CLAUSULAS = ['Geral', 'Consultoria', 'Treinamento', 'Auditoria', 'SaaS KzeroSystem', 'Personalizado'];

// Banco padrão de cláusulas (seed inicial quando nenhum banco existe)
export const BANCO_CLAUSULAS_PADRAO = [
  { id: 'b_conf', categoria: 'Geral', titulo: 'CONFIDENCIALIDADE', texto: 'As partes se comprometem a manter sigilo sobre todas as informações trocadas no âmbito deste contrato, pelo prazo de 2 (dois) anos após o término dos serviços.' },
  { id: 'b_pi',   categoria: 'Geral', titulo: 'PROPRIEDADE INTELECTUAL', texto: 'Todos os materiais, metodologias e entregáveis desenvolvidos no âmbito desta proposta são de propriedade da Kzero Consultoria, sendo cedido ao Cliente o direito de uso após quitação integral do valor.' },
  { id: 'b_res',  categoria: 'Geral', titulo: 'RESCISÃO', texto: 'Qualquer das partes poderá rescindir o presente contrato mediante notificação prévia de 15 (quinze) dias, ficando devidos os valores proporcionais aos serviços já prestados.' },
  { id: 'b_pgto', categoria: 'Geral', titulo: 'INADIMPLÊNCIA', texto: 'O atraso no pagamento superior a 5 (cinco) dias úteis ensejará cobrança de multa de 2% e juros de 1% ao mês sobre o valor devido, além de honorários advocatícios de 10% em caso de cobrança judicial.' },
  { id: 'b_foro', categoria: 'Geral', titulo: 'FORO', texto: 'Fica eleito o foro da comarca de [CIDADE], Estado de [ESTADO], para dirimir quaisquer controvérsias oriundas do presente contrato, com renúncia expressa a qualquer outro.' },
  { id: 'b_cons_esc', categoria: 'Consultoria', titulo: 'ESCOPO DE CONSULTORIA', texto: 'Os serviços de consultoria serão prestados conforme escopo definido nesta proposta, não estando incluídas atividades operacionais, execução de processos internos do Cliente ou implementação de sistemas.' },
  { id: 'b_cons_ded', categoria: 'Consultoria', titulo: 'DEDICAÇÃO E DISPONIBILIDADE', texto: 'A Kzero Consultoria dedicará os recursos necessários para a execução dos serviços nos prazos acordados, podendo o Cliente solicitar reuniões de acompanhamento com antecedência mínima de 48 horas.' },
  { id: 'b_cons_alt', categoria: 'Consultoria', titulo: 'ALTERAÇÃO DE ESCOPO', texto: 'Qualquer solicitação de alteração de escopo deverá ser formalizada por escrito e poderá implicar revisão de prazo e valor, mediante aditivo contratual assinado por ambas as partes.' },
  { id: 'b_trein_cert', categoria: 'Treinamento', titulo: 'CERTIFICAÇÃO', texto: 'Será emitido certificado de participação aos treinandos com frequência mínima de 75% (setenta e cinco por cento) da carga horária total do treinamento.' },
  { id: 'b_trein_freq', categoria: 'Treinamento', titulo: 'FREQUÊNCIA E PONTUALIDADE', texto: 'O Cliente deverá garantir a presença e pontualidade dos participantes. Atrasos superiores a 15 minutos poderão impedir o acesso à sessão, sem direito a reposição.' },
  { id: 'b_trein_canc', categoria: 'Treinamento', titulo: 'CANCELAMENTO DE TURMA', texto: 'O cancelamento pelo Cliente com antecedência inferior a 5 (cinco) dias úteis implicará cobrança de 50% do valor contratado a título de taxa de cancelamento.' },
  { id: 'b_trein_mat', categoria: 'Treinamento', titulo: 'MATERIAL DIDÁTICO', texto: 'O material didático fornecido durante o treinamento é de propriedade da Kzero Consultoria, sendo proibida sua reprodução, comercialização ou compartilhamento sem autorização expressa.' },
  { id: 'b_aud_acesso', categoria: 'Auditoria', titulo: 'ACESSO E COOPERAÇÃO', texto: 'O Cliente compromete-se a fornecer acesso irrestrito às instalações, documentos, registros e colaboradores necessários para a realização da auditoria no prazo acordado.' },
  { id: 'b_aud_rel', categoria: 'Auditoria', titulo: 'RELATÓRIO DE AUDITORIA', texto: 'O relatório de auditoria é documento confidencial, destinado exclusivamente à gestão do Cliente. Sua divulgação a terceiros sem anuência da Kzero Consultoria é expressamente vedada.' },
  { id: 'b_aud_nao_conf', categoria: 'Auditoria', titulo: 'NÃO CONFORMIDADES', texto: 'A identificação de não conformidades durante a auditoria não implica responsabilidade da Kzero Consultoria por fatos anteriores, sendo o prazo de implementação de ações corretivas de responsabilidade exclusiva do Cliente.' },

  // ═══════════════════════════════════════════════════════════════
  // SaaS KzeroSystem — contrato de prestação de serviço de software
  // Versão enxuta 2026-04-11 (remoção de afirmações factuais inverídicas
  // e de compromissos operacionais quantitativos não sustentáveis)
  // ═══════════════════════════════════════════════════════════════
  { id: 'b_saas_objeto', categoria: 'SaaS KzeroSystem', titulo: 'OBJETO DO CONTRATO', texto: 'O presente contrato tem por objeto a concessão, pela CONTRATADA à CONTRATANTE, de licença de uso temporária, não exclusiva e intransferível da plataforma KzeroSystem — Sistema de Gestão da Qualidade (SGQ) — disponibilizada na modalidade Software as a Service (SaaS), nos limites do plano comercial descrito nesta proposta.' },
  { id: 'b_saas_natureza', categoria: 'SaaS KzeroSystem', titulo: 'NATUREZA DO SERVIÇO (SaaS)', texto: 'O KzeroSystem é prestado exclusivamente na modalidade Software as a Service (SaaS), hospedado em infraestrutura de nuvem contratada pela CONTRATADA. A CONTRATANTE recebe direito de acesso e uso, não se operando cessão, alienação ou transferência do software, código-fonte ou binários.' },
  { id: 'b_saas_licenca', categoria: 'SaaS KzeroSystem', titulo: 'LICENÇA DE USO', texto: 'A CONTRATADA concede à CONTRATANTE licença temporária, pessoal, não exclusiva e intransferível de uso da plataforma, exclusivamente para as finalidades internas legítimas de seu negócio. É vedado sublicenciar, revender, disponibilizar o acesso a terceiros alheios à organização contratante ou realizar engenharia reversa, ressalvadas as hipóteses legais.' },
  { id: 'b_saas_vigencia', categoria: 'SaaS KzeroSystem', titulo: 'VIGÊNCIA E RENOVAÇÃO', texto: 'O contrato vigora por 12 (doze) meses contados da ativação do acesso, prorrogando-se automaticamente por iguais períodos, salvo manifestação em contrário de qualquer das partes, por escrito, com antecedência mínima de 30 (trinta) dias do término da vigência corrente. Eventual reajuste será informado previamente pela CONTRATADA.' },
  { id: 'b_saas_valor', categoria: 'SaaS KzeroSystem', titulo: 'VALOR E FORMA DE PAGAMENTO', texto: 'A CONTRATANTE pagará à CONTRATADA o valor mensal de [VALOR], com vencimento no dia [DIA] de cada mês, mediante emissão de Nota Fiscal de Serviço. Havendo atraso superior a 10 (dez) dias, a CONTRATADA poderá, após notificação, suspender o acesso à plataforma até a regularização.' },
  { id: 'b_saas_reajuste', categoria: 'SaaS KzeroSystem', titulo: 'REAJUSTE ANUAL', texto: 'Os valores contratados serão reajustados anualmente pela variação positiva do IPCA/IBGE apurada nos 12 (doze) meses imediatamente anteriores à data-base, a cada renovação. A CONTRATADA comunicará previamente o novo valor.' },
  { id: 'b_saas_sla', categoria: 'SaaS KzeroSystem', titulo: 'DISPONIBILIDADE E SUPORTE', texto: 'A CONTRATADA empenhará esforços razoáveis para manter a plataforma disponível, podendo realizar janelas programadas de manutenção, comunicadas previamente sempre que possível. Eventos de força maior, indisponibilidade de conexão da CONTRATANTE e atos de terceiros não caracterizam descumprimento contratual. O suporte técnico é prestado em dias úteis, por sistema de tickets e e-mail.' },
  { id: 'b_saas_dados', categoria: 'SaaS KzeroSystem', titulo: 'TITULARIDADE DOS DADOS', texto: 'Os registros inseridos pela CONTRATANTE na plataforma são de sua titularidade. Os dados pessoais tratados pertencem, quanto à titularidade, às respectivas pessoas naturais (art. 17 LGPD): a CONTRATANTE atua como controladora e a CONTRATADA como operadora, restrita às instruções do contrato. A CONTRATADA não utiliza os dados para finalidades alheias à execução deste contrato.' },
  { id: 'b_saas_lgpd', categoria: 'SaaS KzeroSystem', titulo: 'PROTEÇÃO DE DADOS (LGPD)', texto: 'As partes comprometem-se a observar a Lei nº 13.709/2018 (LGPD) no âmbito deste contrato. A CONTRATADA atua como operadora dos dados pessoais tratados por intermédio da plataforma e adota medidas técnicas e administrativas razoáveis de segurança compatíveis com o estado da arte e com a natureza do serviço. A CONTRATADA designou Encarregado pela Proteção de Dados (DPO), cujos contatos estão disponíveis na Política de Privacidade publicada no endereço eletrônico da plataforma.' },
  { id: 'b_saas_backup', categoria: 'SaaS KzeroSystem', titulo: 'BACKUP E PORTABILIDADE', texto: 'A CONTRATADA mantém rotinas regulares de backup dos dados da plataforma. Encerrado o contrato por qualquer motivo, a CONTRATANTE poderá solicitar, em prazo razoável, a exportação de seus dados em formato interoperável. A eliminação definitiva dos dados observa as obrigações legais de retenção aplicáveis.' },
  { id: 'b_saas_seguranca', categoria: 'SaaS KzeroSystem', titulo: 'SEGURANÇA DA INFORMAÇÃO', texto: 'A CONTRATADA adota medidas técnicas e administrativas razoáveis de segurança da informação, incluindo, no mínimo, criptografia em trânsito, controle de acesso por perfil e segregação lógica entre empresas clientes. Nenhum sistema está isento de riscos, e a CONTRATANTE reconhece que compete a ambas as partes colaborar para a proteção das informações, incluindo a gestão responsável de credenciais por seus usuários.' },
  { id: 'b_saas_suporte', categoria: 'SaaS KzeroSystem', titulo: 'CANAIS DE SUPORTE', texto: 'O suporte técnico é prestado prioritariamente pelo sistema de tickets integrado à plataforma, com redundância por e-mail. O atendimento observa ordem de prioridade conforme severidade registrada, em dias úteis.' },
  { id: 'b_saas_treinamento', categoria: 'SaaS KzeroSystem', titulo: 'TREINAMENTO E ATIVAÇÃO', texto: 'A contratação inclui sessão de onboarding remoto por videoconferência para a equipe da CONTRATANTE, acesso à base de conhecimento e aos vídeos tutoriais disponibilizados na plataforma. Treinamentos adicionais, presenciais ou customizados, serão objeto de proposta comercial específica.' },
  { id: 'b_saas_limitacao', categoria: 'SaaS KzeroSystem', titulo: 'LIMITAÇÃO DE RESPONSABILIDADE', texto: 'Ressalvadas as hipóteses de dolo, culpa grave e obrigações decorrentes da Lei nº 13.709/2018, a responsabilidade civil da CONTRATADA por fatos decorrentes deste contrato limita-se ao valor equivalente às 6 (seis) últimas mensalidades efetivamente pagas pela CONTRATANTE. Não constituem responsabilidade da CONTRATADA: indisponibilidade da conexão de internet da CONTRATANTE, falhas em seus equipamentos, atos de usuários da CONTRATANTE, ou decisões tomadas pela CONTRATANTE com base em relatórios e indicadores gerados pela plataforma.' },
  { id: 'b_saas_rescisao', categoria: 'SaaS KzeroSystem', titulo: 'RESCISÃO', texto: 'A CONTRATANTE pode rescindir o contrato mediante notificação por escrito com antecedência mínima de 30 (trinta) dias, pagando integralmente as mensalidades vencidas e a proporcional do mês em curso. A rescisão por inadimplência da CONTRATANTE poderá ocorrer após 30 (trinta) dias de atraso, mediante aviso prévio. Aplica-se, ao encerramento, o previsto na cláusula de Backup e Portabilidade.' },
  { id: 'b_saas_alteracao', categoria: 'SaaS KzeroSystem', titulo: 'EVOLUÇÃO DO SOFTWARE', texto: 'A CONTRATADA realizará, sem custo adicional, correções, atualizações e melhorias da plataforma. Alterações que impliquem redução significativa de funcionalidade contratada serão comunicadas previamente, assegurando-se à CONTRATANTE o direito de rescisão sem ônus, com reembolso proporcional se aplicável.' },
  { id: 'b_saas_forca_maior', categoria: 'SaaS KzeroSystem', titulo: 'FORÇA MAIOR', texto: 'Nenhuma das partes responderá por inexecução de obrigações decorrente de caso fortuito ou força maior, nos termos do art. 393 do Código Civil, incluindo eventos naturais catastróficos, atos governamentais, guerra, pandemias oficialmente declaradas e falhas sistêmicas de provedores globais de infraestrutura, subsistindo, em qualquer caso, o dever de comunicação imediata e de adoção de medidas mitigadoras.' },
  { id: 'b_saas_lei_aplicavel', categoria: 'SaaS KzeroSystem', titulo: 'LEI APLICÁVEL', texto: 'Este contrato é regido pelas leis da República Federativa do Brasil, interpretando-se em língua portuguesa.' },
];

// ─── Template de Contrato SaaS KzeroSystem ─────────────────────────
// Ordem jurídica das cláusulas no contrato SaaS
const CLAUSULAS_SAAS_TEMPLATE_IDS = [
  'b_saas_objeto', 'b_saas_natureza', 'b_saas_licenca', 'b_saas_vigencia',
  'b_saas_valor', 'b_pgto', 'b_saas_reajuste', 'b_saas_sla', 'b_saas_suporte',
  'b_saas_treinamento', 'b_saas_dados', 'b_saas_lgpd', 'b_saas_backup',
  'b_saas_seguranca', 'b_conf', 'b_saas_limitacao', 'b_saas_forca_maior',
  'b_saas_alteracao', 'b_saas_rescisao', 'b_saas_lei_aplicavel', 'b_foro',
];

export const TEMPLATE_SAAS_KZEROSYSTEM = {
  responsavel: 'Kzerosystem Ltda',
  objetivo: 'Fornecimento de licença de uso da plataforma KzeroSystem — Sistema de Gestão da Qualidade — na modalidade SaaS (Software as a Service), incluindo hospedagem em nuvem, manutenção, atualizações, suporte técnico e capacitação inicial dos usuários.',
  escopo: 'Plano contratado: [STARTER | PROFESSIONAL | ENTERPRISE]\nNúmero de usuários: [QTD]\nMódulos habilitados: conforme plano contratado\nDomínio de acesso: https://www.kzerosystem.com.br',
  entregas: '1. Ambiente da empresa provisionado e ativado\n2. Usuários administradores cadastrados com credenciais iniciais\n3. Configuração inicial de parâmetros, cargos e estrutura organizacional\n4. Sessão de onboarding remoto\n5. Acesso à base de conhecimento e tutoriais\n6. Suporte técnico durante a vigência',
  metodologia: 'A ativação segue processo padronizado de provisionamento do ambiente, criação do usuário administrador, envio de credenciais de acesso, agendamento do onboarding e acompanhamento pela equipe de sucesso do cliente.',
  cronograma: 'Ativação do ambiente após assinatura do contrato.\nOnboarding remoto agendado conforme disponibilidade.\nSuporte contínuo durante toda a vigência do contrato.',
  valor: 'Mensalidade de R$ [VALOR] (valor por extenso), com faturamento mensal no dia [DIA] de cada mês. Reajuste anual pelo IPCA.',
  formaPagamento: 'Boleto bancário, transferência PIX ou depósito em conta corrente da Kzerosystem Ltda, com emissão de Nota Fiscal de Serviço Eletrônica (NFS-e) enviada por email.',
  condicoesEspeciais: 'Período mínimo de vigência: 12 meses. Descontos para contratação anual à vista ou multi-empresas mediante negociação.',
  observacoes: '',
};

// Cláusulas padrão que aparecem em toda proposta nova (subconjunto do banco)
const CLAUSULAS_PADRAO = BANCO_CLAUSULAS_PADRAO
  .filter(c => ['b_conf','b_pi','b_res'].includes(c.id))
  .map(c => ({ id: c.id, titulo: c.titulo, texto: c.texto, ativa: true }));

const FORM_VAZIO = () => ({
  id: null,
  cliente: '',
  responsavel: '',
  data: new Date().toISOString().split('T')[0],
  validade: '',
  status: 'RASCUNHO',
  objetivo: '',
  escopo: '',
  entregas: '',
  metodologia: '',
  cronograma: '',
  valor: '',
  formaPagamento: '',
  condicoesEspeciais: '',
  clausulas: CLAUSULAS_PADRAO.map(c => ({ ...c })),
  observacoes: '',
});

export function Propostas({ propostas, setPropostas, clientes, profissionalAtual, isAdmin, bancoClausulas, setBancoClausulas }) {
  const banco = bancoClausulas?.length ? bancoClausulas : BANCO_CLAUSULAS_PADRAO;
  const salvarBanco = setBancoClausulas || (() => {});

  const [form, setForm]           = useState(null);
  const [preview, setPreview]     = useState(null);
  const [expandido, setExpandido] = useState({});
  const [abaForm, setAbaForm]     = useState('conteudo');
  const [analisandoIA, setAnalisandoIA] = useState(false);
  const [editandoClausula, setEditandoClausula] = useState(null);
  const [novaClausula, setNovaClausula]         = useState(null);

  // ─── Banco de Cláusulas ───────────────────────────────────────────────────
  const [bancoAberto, setBancoAberto]           = useState(false);
  const [bancoCatFiltro, setBancoCatFiltro]     = useState('Todas');
  const [bancoEditando, setBancoEditando]       = useState(null); // {id, titulo, texto, categoria}
  const [bancoCriando, setBancoCriando]         = useState(null); // {titulo, texto, categoria}
  // Importar do banco para a proposta
  const [importFiltro, setImportFiltro]         = useState('Todas');
  const [importSelecionados, setImportSelecionados] = useState([]);

  const analisarComIA = async () => {
    if (!form?.objetivo?.trim()) { toast.aviso('Escreva o objetivo antes de analisar com IA.'); return; }
    setAnalisandoIA(true);
    try {
      // Proxy server-side (/api/proposta-ia) — usa Gemini Flash 2.0 (grátis,
      // 1.500 reqs/dia). Chave fica só no Vercel; nada de credencial no bundle.
      const res = await fetch('/api/proposta-ia', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ objetivo: form.objetivo }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(body?.error || `HTTP ${res.status}`);
      }
      const json = body?.data || {};
      setForm(f => ({
        ...f,
        escopo:      json.escopo      || f.escopo,
        entregas:    json.entregas    || f.entregas,
        metodologia: json.metodologia || f.metodologia,
        cronograma:  json.cronograma  || f.cronograma,
      }));
      toast.sucesso('Proposta preenchida com IA! Revise e ajuste conforme necessário.');
    } catch (e) {
      toast.erro(e.message);
    } finally {
      setAnalisandoIA(false);
    }
  };

  const novo  = () => { setForm({ ...FORM_VAZIO(), profissional: profissionalAtual||'' }); setAbaForm('conteudo'); };
  const novoSaaS = () => {
    // Template reformulado em 2026-04-11: remoção de afirmações factuais sobre LGPD
    // ("aplicando criptografia/auditoria/backup/DPO") substituídas por linguagem genérica,
    // remoção de SLA 99% e prazos específicos de resposta, remoção de referências nominais
    // a subprocessadores. Cláusulas de força maior, lei aplicável acrescentadas.
    const clausulasSaaS = CLAUSULAS_SAAS_TEMPLATE_IDS
      .map(id => BANCO_CLAUSULAS_PADRAO.find(c => c.id === id))
      .filter(Boolean)
      .map(c => ({ id: c.id, titulo: c.titulo, texto: c.texto, ativa: true }));
    setForm({
      ...FORM_VAZIO(),
      ...TEMPLATE_SAAS_KZEROSYSTEM,
      profissional: profissionalAtual || '',
      clausulas: clausulasSaaS,
    });
    setAbaForm('conteudo');
    toast.sucesso('Template "Contrato SaaS KzeroSystem" carregado. Preencha o cliente, valor e ajuste conforme a negociação.');
  };
  const editar = (p) => {
    // Garante que propostas antigas sem clausulas recebam as padrão
    setForm({ ...FORM_VAZIO(), ...p, clausulas: p.clausulas || CLAUSULAS_PADRAO.map(c => ({ ...c })) });
    setAbaForm('conteudo');
  };
  const fechar = () => { setForm(null); setEditandoClausula(null); setNovaClausula(null); };

  const salvar = () => {
    if (!form.cliente || !form.objetivo) { toast.aviso('Preencha pelo menos o cliente e o objetivo.'); return; }
    const editando = form.id && propostas.find(p => p.id === form.id);
    setPropostas(editando
      ? propostas.map(p => p.id === form.id ? form : p)
      : [...propostas, { ...form, id: Date.now() }]);
    toast.sucesso(editando ? 'Proposta atualizada!' : 'Proposta criada!');
    fechar();
  };

  const excluir = (id) => { if (window.confirm('Excluir esta proposta?')) { setPropostas(propostas.filter(p => p.id !== id)); toast.sucesso('Proposta excluída.'); } };
  const propostasVisiveis = isAdmin ? propostas : propostas.filter(p => !p.profissional || p.profissional === profissionalAtual);
  const duplicar = (p) => { setPropostas([...propostas, { ...p, id: Date.now(), status: 'RASCUNHO', data: new Date().toISOString().split('T')[0] }]); toast.info('Proposta duplicada.'); };

  // ─── Cláusulas do formulário ──────────────────────────────────────────────
  const toggleClausula = (id) => {
    setForm(f => ({ ...f, clausulas: f.clausulas.map(c => c.id === id ? { ...c, ativa: !c.ativa } : c) }));
  };

  const atualizarClausula = (id, campo, valor) => {
    setForm(f => ({ ...f, clausulas: f.clausulas.map(c => c.id === id ? { ...c, [campo]: valor } : c) }));
  };

  const adicionarClausula = () => {
    if (!novaClausula?.titulo?.trim()) return;
    const nova = { id: Date.now(), titulo: novaClausula.titulo.trim().toUpperCase(), texto: novaClausula.texto || '', ativa: true };
    setForm(f => ({ ...f, clausulas: [...f.clausulas, nova] }));
    setNovaClausula(null);
  };

  const removerClausula = (id) => {
    setForm(f => ({ ...f, clausulas: f.clausulas.filter(c => c.id !== id) }));
  };

  const moverClausula = (id, dir) => {
    setForm(f => {
      const arr = [...f.clausulas];
      const idx = arr.findIndex(c => c.id === id);
      const novoIdx = idx + dir;
      if (novoIdx < 0 || novoIdx >= arr.length) return f;
      [arr[idx], arr[novoIdx]] = [arr[novoIdx], arr[idx]];
      return { ...f, clausulas: arr };
    });
  };

  // ─── Banco de Cláusulas — CRUD ───────────────────────────────────────────
  const salvarClausulaBanco = () => {
    if (!bancoEditando?.titulo?.trim()) return;
    salvarBanco(banco.map(c => c.id === bancoEditando.id ? { ...bancoEditando, titulo: bancoEditando.titulo.toUpperCase() } : c));
    setBancoEditando(null);
  };

  const criarClausulaBanco = () => {
    if (!bancoCriando?.titulo?.trim()) return;
    const nova = { id: `b_${Date.now()}`, titulo: bancoCriando.titulo.trim().toUpperCase(), texto: bancoCriando.texto || '', categoria: bancoCriando.categoria || 'Personalizado' };
    salvarBanco([...banco, nova]);
    setBancoCriando(null);
  };

  const excluirClausulaBanco = (id) => {
    if (window.confirm('Excluir esta cláusula do banco?')) salvarBanco(banco.filter(c => c.id !== id));
  };

  // Importar cláusulas selecionadas do banco para a proposta atual
  const importarSelecionadas = () => {
    if (!form || importSelecionados.length === 0) return;
    const jaIds = new Set((form.clausulas || []).map(c => c.id));
    const novas = banco
      .filter(c => importSelecionados.includes(c.id) && !jaIds.has(c.id))
      .map(c => ({ id: c.id + '_' + Date.now(), titulo: c.titulo, texto: c.texto, ativa: true }));
    setForm(f => ({ ...f, clausulas: [...(f.clausulas || []), ...novas] }));
    setImportSelecionados([]);
  };

  const toggleImportSel = (id) => setImportSelecionados(sel => sel.includes(id) ? sel.filter(s => s !== id) : [...sel, id]);

  // ─── Gerar texto ─────────────────────────────────────────────────────────
  const gerarTexto = (p) => {
    const fmtData = (d) => d ? new Date(d+'T00:00').toLocaleDateString('pt-BR',{day:'2-digit',month:'long',year:'numeric'}) : '—';
    const clausulasAtivas = (p.clausulas || CLAUSULAS_PADRAO).filter(c => c.ativa);
    const cnpjTxt = cnpjFormatado((clientes || []).find(c => c?.nome && c.nome === p.cliente)?.cnpj);

    const secoes = [
      p.objetivo    && `───────────────────────────────────────────────────\n1. OBJETIVO\n───────────────────────────────────────────────────\n${p.objetivo}`,
      p.escopo      && `───────────────────────────────────────────────────\n2. ESCOPO DOS SERVIÇOS\n───────────────────────────────────────────────────\n${p.escopo}`,
      p.entregas    && `───────────────────────────────────────────────────\n3. ENTREGAS PREVISTAS\n───────────────────────────────────────────────────\n${p.entregas}`,
      p.metodologia && `───────────────────────────────────────────────────\n4. METODOLOGIA E ABORDAGEM\n───────────────────────────────────────────────────\n${p.metodologia}`,
      p.cronograma  && `───────────────────────────────────────────────────\n5. CRONOGRAMA\n───────────────────────────────────────────────────\n${p.cronograma}`,
    ].filter(Boolean);

    return `PROPOSTA COMERCIAL / PRÉ-CONTRATO
═══════════════════════════════════════════════════

Kzero Consultoria
Data: ${fmtData(p.data)}
Validade: ${fmtData(p.validade)}

CLIENTE: ${p.cliente}${cnpjTxt ? `
CNPJ: ${cnpjTxt}` : ''}
${p.responsavel ? `RESPONSÁVEL: ${p.responsavel}` : ''}

${secoes.join('\n\n')}

───────────────────────────────────────────────────
${secoes.length + 1}. INVESTIMENTO
───────────────────────────────────────────────────
Valor Total: ${p.valor ? `R$ ${parseFloat(p.valor).toLocaleString('pt-BR',{minimumFractionDigits:2, maximumFractionDigits:2})}` : 'A definir'}
Forma de Pagamento: ${p.formaPagamento || 'A definir'}
${p.condicoesEspeciais ? `\nCondições Especiais:\n${p.condicoesEspeciais}` : ''}

───────────────────────────────────────────────────
${secoes.length + 2}. CLÁUSULAS CONTRATUAIS
───────────────────────────────────────────────────
${clausulasAtivas.length === 0 ? 'Nenhuma cláusula incluída.' : clausulasAtivas.map(c => `✓ ${c.titulo}:\n${c.texto}`).join('\n\n')}

───────────────────────────────────────────────────
${secoes.length + 3}. ACEITE
───────────────────────────────────────────────────
A assinatura ou confirmação por e-mail desta proposta configura aceite formal dos termos acima.
${p.observacoes ? `\nOBSERVAÇÕES:\n${p.observacoes}\n` : ''}

___________________________          ___________________________
Kzero Consultoria                    Cliente: ${p.cliente}
Data: ___/___/______                 Data: ___/___/______
`;
  };

  const exportarTxt = (p) => {
    const blob = new Blob([gerarTexto(p)], { type: 'text/plain;charset=utf-8' });
    const url  = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Proposta_${(p.cliente||'cliente').replace(/\s+/g,'_')}_${p.data}.txt`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="m-container" style={s.container}>
      <div style={s.header}>
        <h2 style={s.titulo}>Propostas Comerciais</h2>
        <div style={{ display:'flex', gap:'0.5rem' }}>
          <button style={s.btnBanco} onClick={() => setBancoAberto(true)}><Library size={15}/> Banco de Cláusulas</button>
          {!form && <button style={{...s.btnNovo, background:'#0000FF'}} onClick={novoSaaS} title="Criar contrato SaaS do KzeroSystem com cláusulas pré-preenchidas"><FileText size={16}/> Contrato SaaS KzeroSystem</button>}
          {!form && <button style={s.btnNovo} onClick={novo}><Plus size={16}/> Nova Proposta</button>}
        </div>
      </div>

      {/* Resumo por status */}
      <div className="mobile-grid-1" style={s.statusGrid}>
        {Object.entries(STATUS_COR).map(([st, cor]) => (
          <div key={st} style={s.statusCard}>
            <span style={{...s.statusBadge, color:cor, borderColor:cor}}>{st}</span>
            <div style={{...s.statusNum, color:cor}}>{propostas.filter(p=>(p.status||'RASCUNHO')===st).length}</div>
          </div>
        ))}
      </div>

      {/* ─── FORMULÁRIO ──────────────────────────────────────────────────── */}
      {form && (
        <div style={s.formCard}>
          <h3 style={s.formTitulo}>{form.id && propostas.find(p=>p.id===form.id) ? '✏️ Editar Proposta' : '📄 Nova Proposta'}</h3>

          {/* Sub-abas do formulário */}
          <div style={s.formAbas}>
            {[['conteudo','📝 Conteúdo'],['investimento','💰 Investimento'],['clausulas','⚖️ Cláusulas']].map(([id,lb]) => (
              <button key={id} style={{...s.formAba,...(abaForm===id?s.formAbaAtiva:{})}} onClick={() => setAbaForm(id)}>{lb}</button>
            ))}
          </div>

          {/* ── Conteúdo ── */}
          {abaForm === 'conteudo' && (
            <>
              <div style={s.secaoForm}>
                <div style={s.secaoLabel}>Identificação</div>
                <div style={s.formRow}>
                  <div style={s.campo}>
                    <label style={s.label}>Cliente *</label>
                    {clientes.length > 0
                      ? <select style={s.input} value={form.cliente} onChange={e => setForm({...form, cliente:e.target.value})}>
                          <option value="">Selecione o cliente</option>
                          {clientes.map(c => <option key={c.id} value={c.nome}>{c.nome}</option>)}
                        </select>
                      : <input type="text" style={s.input} value={form.cliente} placeholder="Nome do cliente" onChange={e => setForm({...form, cliente:e.target.value})} />
                    }
                  </div>
                  <div style={s.campo}>
                    <label style={s.label}>Responsável / Contato</label>
                    <input type="text" style={s.input} value={form.responsavel} placeholder="Nome do responsável" onChange={e => setForm({...form, responsavel:e.target.value})} />
                  </div>
                </div>
                <div style={s.formRow}>
                  <div style={s.campo}><label style={s.label}>Data</label><input type="date" style={s.input} value={form.data} onChange={e => setForm({...form, data:e.target.value})} /></div>
                  <div style={s.campo}><label style={s.label}>Validade</label><input type="date" style={s.input} value={form.validade} onChange={e => setForm({...form, validade:e.target.value})} /></div>
                  <div style={s.campo}>
                    <label style={s.label}>Status</label>
                    <select style={s.input} value={form.status} onChange={e => setForm({...form, status:e.target.value})}>
                      {Object.keys(STATUS_COR).map(st => <option key={st} value={st}>{st}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              <div style={s.campo}>
                <label style={s.label}>Objetivo *</label>
                <textarea style={{...s.input, resize:'vertical', minHeight:70, lineHeight:1.6}} value={form.objetivo} placeholder="Descreva o objetivo principal da consultoria..." rows={3} onChange={e => setForm({...form, objetivo:e.target.value})} />
              </div>

              <div style={{display:'flex', justifyContent:'flex-end', margin:'-8px 0 4px'}}>
                <button
                  onClick={analisarComIA}
                  disabled={analisandoIA || !form.objetivo?.trim()}
                  style={{
                    display:'flex', alignItems:'center', gap:'6px',
                    padding:'7px 16px', borderRadius:8, border:'none', cursor:'pointer',
                    background: analisandoIA ? '#4c1d95' : 'linear-gradient(135deg,#7c3aed,#6d28d9)',
                    color:'#fff', fontSize:'0.82rem', fontWeight:600,
                    opacity: !form.objetivo?.trim() ? 0.5 : 1,
                    transition:'opacity .2s',
                  }}
                  title="Preencher escopo, entregas, metodologia e cronograma com IA"
                >
                  <Sparkles size={14} />
                  {analisandoIA ? 'Analisando...' : 'Analisar com IA'}
                </button>
              </div>

              {[
                { key:'escopo',      label:'Escopo dos Serviços',    ph:'Liste as atividades e serviços incluídos...' },
                { key:'entregas',    label:'Entregas Previstas',     ph:'Descreva os entregáveis: relatórios, workshops, apresentações...' },
                { key:'metodologia', label:'Metodologia / Abordagem',ph:'Como será conduzido o trabalho: entrevistas, análise, workshops...' },
                { key:'cronograma',  label:'Cronograma',             ph:'Fase 1 (Semana 1-2): Diagnóstico\nFase 2 (Semana 3-4): Análise\nFase 3 (Semana 5-6): Entrega' },
              ].map(f => (
                <div key={f.key} style={s.campo}>
                  <label style={s.label}>{f.label}</label>
                  <textarea style={{...s.input, resize:'vertical', minHeight:70, lineHeight:1.6}} value={form[f.key]} placeholder={f.ph} rows={3} onChange={e => setForm({...form, [f.key]:e.target.value})} />
                </div>
              ))}

              <div style={s.campo}>
                <label style={s.label}>Observações finais</label>
                <textarea style={{...s.input, resize:'vertical'}} value={form.observacoes} placeholder="Informações adicionais, condições especiais..." rows={2} onChange={e => setForm({...form, observacoes:e.target.value})} />
              </div>
            </>
          )}

          {/* ── Investimento ── */}
          {abaForm === 'investimento' && (
            <div style={s.secaoForm}>
              <div style={s.secaoLabel}>Investimento</div>
              <div style={s.formRow}>
                <div style={s.campo}>
                  <label style={s.label}>Valor Total (R$)</label>
                  <input type="number" style={s.input} value={form.valor} step="0.01" placeholder="0,00" onChange={e => setForm({...form, valor:e.target.value})} />
                </div>
                <div style={{...s.campo, flex:2}}>
                  <label style={s.label}>Forma de Pagamento</label>
                  <input type="text" style={s.input} value={form.formaPagamento} placeholder="Ex: 50% na assinatura + 50% na entrega final" onChange={e => setForm({...form, formaPagamento:e.target.value})} />
                </div>
              </div>
              <div style={s.campo}>
                <label style={s.label}>Condições Especiais (descontos, bônus, etc.)</label>
                <textarea style={{...s.input, resize:'vertical'}} value={form.condicoesEspeciais} rows={3} placeholder="Descontos por volume, bônus por antecipação, etc." onChange={e => setForm({...form, condicoesEspeciais:e.target.value})} />
              </div>
            </div>
          )}

          {/* ── Cláusulas ── */}
          {abaForm === 'clausulas' && (
            <div style={{display:'flex', flexDirection:'column', gap:'1rem'}}>
              <div style={s.clausulasInfo}>
                ⚖️ Ative/desative, edite o texto ou crie novas cláusulas. As alterações valem apenas para <strong>esta proposta</strong>.
              </div>

              {(form.clausulas || []).map((cl, idx) => (
                <div key={cl.id} style={{...s.clausulaCard, ...(cl.ativa?{}:{opacity:0.45})}}>
                  <div style={s.clausulaHeaderRow}>
                    {/* Toggle ativa */}
                    <label style={s.checkRow}>
                      <input type="checkbox" checked={cl.ativa} onChange={() => toggleClausula(cl.id)} style={{width:16,height:16,accentColor:'#7c3aed'}} />
                      {editandoClausula === cl.id
                        ? <input type="text" style={{...s.inputTitulo}} value={cl.titulo} onChange={e => atualizarClausula(cl.id, 'titulo', e.target.value.toUpperCase())} />
                        : <span style={s.clausulaTitulo}>{cl.titulo}</span>
                      }
                    </label>
                    {/* Ações */}
                    <div style={s.clausulaAcoes}>
                      <button style={s.btnMover} onClick={() => moverClausula(cl.id, -1)} disabled={idx===0} title="Mover para cima">↑</button>
                      <button style={s.btnMover} onClick={() => moverClausula(cl.id, 1)} disabled={idx===(form.clausulas.length-1)} title="Mover para baixo">↓</button>
                      <button style={s.btnEditCl} onClick={() => setEditandoClausula(editandoClausula===cl.id ? null : cl.id)}>
                        <Edit2 size={13}/>
                      </button>
                      <button style={s.btnDelCl} onClick={() => removerClausula(cl.id)}><Trash2 size={13}/></button>
                    </div>
                  </div>
                  {/* Texto editável */}
                  <textarea
                    style={{...s.input, resize:'vertical', marginTop:'0.5rem', fontSize:13, lineHeight:1.6, minHeight:60, opacity: editandoClausula===cl.id ? 1 : 0.85}}
                    value={cl.texto}
                    onChange={e => atualizarClausula(cl.id, 'texto', e.target.value)}
                    readOnly={editandoClausula !== cl.id}
                    rows={3}
                  />
                  {editandoClausula === cl.id && (
                    <button style={{...s.btnSalvarCl}} onClick={() => setEditandoClausula(null)}>✓ Confirmar edição</button>
                  )}
                </div>
              ))}

              {/* Importar do Banco */}
              <div style={s.importBanco}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'0.5rem' }}>
                  <span style={{ fontSize:12, fontWeight:700, color:'#7c3aed', textTransform:'uppercase', letterSpacing:'0.06em' }}>
                    <Library size={13} style={{ verticalAlign:'middle', marginRight:4 }}/>Importar do Banco
                  </span>
                  <div style={{ display:'flex', gap:'0.4rem', flexWrap:'wrap' }}>
                    {['Todas', ...CATEGORIAS_CLAUSULAS].map(cat => (
                      <button key={cat} onClick={() => setImportFiltro(cat)}
                        style={{ ...s.catBtn, ...(importFiltro === cat ? s.catBtnAtivo : {}) }}>
                        {cat}
                      </button>
                    ))}
                  </div>
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:'0.4rem', maxHeight:220, overflowY:'auto', marginTop:'0.5rem' }}>
                  {banco.filter(c => importFiltro === 'Todas' || c.categoria === importFiltro).map(c => {
                    const sel = importSelecionados.includes(c.id);
                    return (
                      <label key={c.id} style={{ ...s.importItem, ...(sel ? s.importItemSel : {}) }}>
                        <input type="checkbox" checked={sel} onChange={() => toggleImportSel(c.id)} style={{ accentColor:'#7c3aed', flexShrink:0 }} />
                        <div style={{ flex:1 }}>
                          <div style={{ fontSize:12, fontWeight:700, color: sel ? '#5b21b6' : '#1c1530' }}>{c.titulo}</div>
                          <div style={{ fontSize:11, color:'#5f5874', lineClamp:2, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>{c.texto}</div>
                        </div>
                        <span style={{ fontSize:10, background:'rgba(124,58,237,0.15)', color:'#8b5cf6', borderRadius:10, padding:'1px 7px', flexShrink:0 }}>{c.categoria}</span>
                      </label>
                    );
                  })}
                  {banco.filter(c => importFiltro === 'Todas' || c.categoria === importFiltro).length === 0 && (
                    <p style={{ fontSize:12, color:'#5f5874', textAlign:'center', padding:'0.75rem' }}>Nenhuma cláusula nesta categoria.</p>
                  )}
                </div>
                {importSelecionados.length > 0 && (
                  <button style={s.btnImportar} onClick={importarSelecionadas}>
                    <Check size={14}/> Importar {importSelecionados.length} cláusula(s) selecionada(s)
                  </button>
                )}
              </div>

              {/* Nova cláusula */}
              {novaClausula === null
                ? <button style={s.btnAddClausula} onClick={() => setNovaClausula({ titulo:'', texto:'' })}>
                    <Plus size={15}/> Adicionar nova cláusula (só nesta proposta)
                  </button>
                : <div style={s.novaClausulaCard}>
                    <div style={s.secaoLabel}>Nova Cláusula</div>
                    <div style={s.campo}>
                      <label style={s.label}>Título da cláusula</label>
                      <input type="text" style={s.input} value={novaClausula.titulo} placeholder="Ex: EXCLUSIVIDADE, SIGILO COMERCIAL..." onChange={e => setNovaClausula({...novaClausula, titulo:e.target.value})} />
                    </div>
                    <div style={s.campo}>
                      <label style={s.label}>Texto da cláusula</label>
                      <textarea style={{...s.input, resize:'vertical', minHeight:80}} value={novaClausula.texto} placeholder="Descreva os termos desta cláusula..." rows={3} onChange={e => setNovaClausula({...novaClausula, texto:e.target.value})} />
                    </div>
                    <div style={{display:'flex', gap:'0.75rem'}}>
                      <button style={s.btnSalvar} onClick={adicionarClausula}>Adicionar</button>
                      <button style={s.btnCancelar} onClick={() => setNovaClausula(null)}>Cancelar</button>
                    </div>
                  </div>
              }
            </div>
          )}

          <div style={s.formActions}>
            <button style={s.btnPreview} onClick={() => setPreview(form)}><Eye size={15}/> Pré-visualizar</button>
            <button style={s.btnSalvar} onClick={salvar}>Salvar Proposta</button>
            <button style={s.btnCancelar} onClick={fechar}>Cancelar</button>
          </div>
        </div>
      )}

      {/* ─── LISTA ─────────────────────────────────────────────────────────── */}
      {propostasVisiveis.length === 0 && !form
        ? <div style={s.vazio}><FileText size={40} color="#e5e0ef"/><p>Nenhuma proposta criada ainda.</p></div>
        : propostasVisiveis.map(p => {
            const cor = STATUS_COR[p.status||'RASCUNHO'] || '#5f5874';
            const exp = expandido[p.id];
            return (
              <div key={p.id} style={s.propostaCard}>
                <div style={s.propostaHeader} onClick={() => setExpandido(prev=>({...prev,[p.id]:!prev[p.id]}))}>
                  <div style={s.propostaInfo}>
                    <div style={s.propostaNome}>{p.cliente || 'Sem cliente'}</div>
                    <div style={s.propostaMeta}>
                      {p.data ? new Date(p.data+'T00:00').toLocaleDateString('pt-BR') : '—'}
                      {p.valor ? ` · R$ ${parseFloat(p.valor).toLocaleString('pt-BR',{minimumFractionDigits:2, maximumFractionDigits:2})}` : ''}
                      {' · '}<span style={{color:'#8b5cf6',fontSize:11}}>{(p.clausulas||CLAUSULAS_PADRAO).filter(c=>c.ativa).length} cláusula(s)</span>
                      {p.oportunidadeId && <span style={{color:'#b45309',fontSize:11,marginLeft:6}}>· 🎯 vinculada à oportunidade</span>}
                    </div>
                  </div>
                  <div style={s.propostaAcoes}>
                    <span style={{...s.badge, color:cor, borderColor:cor}}>{p.status||'RASCUNHO'}</span>
                    <button style={s.btnAcao} onClick={e=>{e.stopPropagation();setPreview(p)}} title="Pré-visualizar"><Eye size={15}/></button>
                    <button style={s.btnAcao} onClick={e=>{e.stopPropagation();exportarPDF(htmlProposta(p, clientes),`Proposta - ${p.cliente||'cliente'}`)}} title="Exportar PDF">PDF</button>
                    <button style={s.btnAcao} onClick={e=>{e.stopPropagation();exportarWord(htmlProposta(p, clientes),`Proposta - ${p.cliente||'cliente'}`)}} title="Exportar Word">DOC</button>
                    <button style={s.btnAcao} onClick={e=>{e.stopPropagation();duplicar(p)}} title="Duplicar"><Copy size={15}/></button>
                    <button style={s.btnAcaoEdit} onClick={e=>{e.stopPropagation();editar(p)}}><Edit2 size={15}/></button>
                    <button style={s.btnAcaoDel} onClick={e=>{e.stopPropagation();excluir(p.id)}}><Trash2 size={15}/></button>
                    {exp ? <ChevronUp size={16} color="#5f5874"/> : <ChevronDown size={16} color="#5f5874"/>}
                  </div>
                </div>
                {exp && (
                  <div style={s.propostaDetalhes}>
                    {p.objetivo && <><div style={s.detalheLabel}>Objetivo</div><div style={s.detalheTexto}>{p.objetivo}</div></>}
                    {p.escopo   && <><div style={s.detalheLabel}>Escopo</div><div style={s.detalheTexto}>{p.escopo}</div></>}
                    {(p.clausulas||CLAUSULAS_PADRAO).filter(c=>c.ativa).length > 0 && (
                      <>
                        <div style={s.detalheLabel}>Cláusulas incluídas</div>
                        <div style={{display:'flex', flexWrap:'wrap', gap:'0.4rem'}}>
                          {(p.clausulas||CLAUSULAS_PADRAO).filter(c=>c.ativa).map(c => (
                            <span key={c.id} style={s.clausulaPill}>{c.titulo}</span>
                          ))}
                        </div>
                      </>
                    )}
                    {p.formaPagamento && <><div style={s.detalheLabel}>Pagamento</div><div style={s.detalheTexto}>{p.formaPagamento}</div></>}
                  </div>
                )}
              </div>
            );
          })
      }

      {/* ─── MODAL BANCO DE CLÁUSULAS ───────────────────────────────────────── */}
      {bancoAberto && (
        <div style={s.overlay} onClick={() => { setBancoAberto(false); setBancoEditando(null); setBancoCriando(null); }}>
          <div style={{ ...s.previewModal, maxWidth:760 }} onClick={e => e.stopPropagation()}>
            <div style={s.previewHeader}>
              <h3 style={s.previewTitulo}><Library size={17} style={{ verticalAlign:'middle', marginRight:6 }}/>Banco de Cláusulas Contratuais</h3>
              <button style={s.modalFechar} onClick={() => { setBancoAberto(false); setBancoEditando(null); setBancoCriando(null); }}><X size={18}/></button>
            </div>

            <div style={{ padding:'1rem 1.5rem', borderBottom:'1px solid #eeeaf5', display:'flex', gap:'0.5rem', flexWrap:'wrap', alignItems:'center' }}>
              {['Todas', ...CATEGORIAS_CLAUSULAS].map(cat => (
                <button key={cat} onClick={() => setBancoCatFiltro(cat)}
                  style={{ ...s.catBtn, ...(bancoCatFiltro === cat ? s.catBtnAtivo : {}) }}>
                  {cat}
                </button>
              ))}
              <button style={{ ...s.btnNovo, marginLeft:'auto', padding:'7px 16px', fontSize:12 }} onClick={() => setBancoCriando({ titulo:'', texto:'', categoria:'Personalizado' })}>
                <Plus size={14}/> Nova Cláusula
              </button>
            </div>

            <div style={{ overflowY:'auto', flex:1, padding:'1rem 1.5rem', display:'flex', flexDirection:'column', gap:'0.75rem' }}>
              {bancoCriando && (
                <div style={s.novaClausulaCard}>
                  <div style={s.secaoLabel}>Nova Cláusula no Banco</div>
                  <div style={{ display:'flex', gap:'0.75rem', flexWrap:'wrap' }}>
                    <div style={{ ...s.campo, flex:2, minWidth:160 }}>
                      <label style={s.label}>Título</label>
                      <input type="text" style={s.input} value={bancoCriando.titulo} placeholder="Ex: EXCLUSIVIDADE" onChange={e => setBancoCriando(b => ({ ...b, titulo: e.target.value }))} />
                    </div>
                    <div style={{ ...s.campo, flex:1, minWidth:130 }}>
                      <label style={s.label}>Categoria</label>
                      <select style={s.input} value={bancoCriando.categoria} onChange={e => setBancoCriando(b => ({ ...b, categoria: e.target.value }))}>
                        {CATEGORIAS_CLAUSULAS.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                  </div>
                  <div style={s.campo}>
                    <label style={s.label}>Texto</label>
                    <textarea style={{ ...s.input, resize:'vertical', minHeight:80 }} value={bancoCriando.texto} placeholder="Descreva os termos desta cláusula..." rows={3} onChange={e => setBancoCriando(b => ({ ...b, texto: e.target.value }))} />
                  </div>
                  <div style={{ display:'flex', gap:'0.75rem' }}>
                    <button style={s.btnSalvar} onClick={criarClausulaBanco}>Salvar no Banco</button>
                    <button style={s.btnCancelar} onClick={() => setBancoCriando(null)}>Cancelar</button>
                  </div>
                </div>
              )}

              {banco.filter(c => bancoCatFiltro === 'Todas' || c.categoria === bancoCatFiltro).map(c => (
                <div key={c.id} style={s.clausulaCard}>
                  {bancoEditando?.id === c.id ? (
                    <div style={{ display:'flex', flexDirection:'column', gap:'0.75rem' }}>
                      <div style={{ display:'flex', gap:'0.75rem', flexWrap:'wrap' }}>
                        <div style={{ ...s.campo, flex:2 }}>
                          <label style={s.label}>Título</label>
                          <input type="text" style={s.input} value={bancoEditando.titulo} onChange={e => setBancoEditando(b => ({ ...b, titulo: e.target.value }))} />
                        </div>
                        <div style={{ ...s.campo, flex:1 }}>
                          <label style={s.label}>Categoria</label>
                          <select style={s.input} value={bancoEditando.categoria} onChange={e => setBancoEditando(b => ({ ...b, categoria: e.target.value }))}>
                            {CATEGORIAS_CLAUSULAS.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                          </select>
                        </div>
                      </div>
                      <div style={s.campo}>
                        <label style={s.label}>Texto</label>
                        <textarea style={{ ...s.input, resize:'vertical', minHeight:80 }} value={bancoEditando.texto} rows={4} onChange={e => setBancoEditando(b => ({ ...b, texto: e.target.value }))} />
                      </div>
                      <div style={{ display:'flex', gap:'0.75rem' }}>
                        <button style={s.btnSalvarCl} onClick={salvarClausulaBanco}>✓ Salvar alterações</button>
                        <button style={s.btnCancelar} onClick={() => setBancoEditando(null)}>Cancelar</button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div style={s.clausulaHeaderRow}>
                        <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', flex:1 }}>
                          <span style={s.clausulaTitulo}>{c.titulo}</span>
                          <span style={{ fontSize:10, background:'rgba(124,58,237,0.15)', color:'#8b5cf6', borderRadius:10, padding:'1px 8px' }}>{c.categoria}</span>
                        </div>
                        <div style={s.clausulaAcoes}>
                          <button style={s.btnEditCl} onClick={() => setBancoEditando({ ...c })}><Edit2 size={13}/></button>
                          <button style={s.btnDelCl} onClick={() => excluirClausulaBanco(c.id)}><Trash2 size={13}/></button>
                        </div>
                      </div>
                      <p style={{ fontSize:12, color:'#5f5874', lineHeight:1.6, margin:0, whiteSpace:'pre-line' }}>{c.texto}</p>
                    </>
                  )}
                </div>
              ))}

              {banco.filter(c => bancoCatFiltro === 'Todas' || c.categoria === bancoCatFiltro).length === 0 && !bancoCriando && (
                <p style={{ fontSize:13, color:'#5f5874', textAlign:'center', padding:'2rem' }}>Nenhuma cláusula nesta categoria.</p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ─── MODAL PREVIEW ─────────────────────────────────────────────────── */}
      {preview && (
        <div style={s.overlay} onClick={() => setPreview(null)}>
          <div style={s.previewModal} onClick={e => e.stopPropagation()}>
            <div style={s.previewHeader}>
              <h3 style={s.previewTitulo}>Pré-visualização — {preview.cliente}</h3>
              <div style={{display:'flex',gap:'0.5rem'}}>
                <button style={s.btnExportar} onClick={() => exportarPDF(htmlProposta(preview, clientes),`Proposta - ${preview.cliente||'cliente'}`)}><Download size={14}/> PDF</button>
                <button style={s.btnExportar} onClick={() => exportarWord(htmlProposta(preview, clientes),`Proposta - ${preview.cliente||'cliente'}`)}><Download size={14}/> Word</button>
                <button style={s.modalFechar} onClick={() => setPreview(null)}><X size={18}/></button>
              </div>
            </div>
            <pre style={s.previewTexto}>{gerarTexto(preview)}</pre>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  container:        { display:'flex', flexDirection:'column', gap:'1.25rem' },
  header:           { display:'flex', justifyContent:'space-between', alignItems:'center' },
  titulo:           { fontSize:'1.8rem', fontWeight:700, color:'#1c1530' },
  btnNovo:          { display:'flex', alignItems:'center', gap:6, background:'#7c3aed', color:'white', border:'none', borderRadius:20, padding:'9px 20px', fontSize:13, fontWeight:600, cursor:'pointer' },
  statusGrid:       { display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(130px,1fr))', gap:'0.75rem' },
  statusCard:       { background:'#ffffff', border:'1px solid #e5e0ef', borderRadius:12, padding:'1rem', display:'flex', flexDirection:'column', gap:'0.4rem' },
  statusBadge:      { fontSize:11, fontWeight:700, border:'1.5px solid', borderRadius:20, padding:'2px 10px', alignSelf:'flex-start', letterSpacing:'0.05em' },
  statusNum:        { fontSize:'1.8rem', fontWeight:700 },
  formCard:         { background:'#ffffff', border:'1px solid #e5e0ef', borderRadius:12, padding:'1.5rem', display:'flex', flexDirection:'column', gap:'1.25rem' },
  formTitulo:       { fontSize:'1.1rem', fontWeight:700, color:'#1c1530', margin:0 },
  formAbas:         { display:'flex', gap:'0.5rem', borderBottom:'1px solid #e5e0ef', paddingBottom:'0.75rem', flexWrap:'wrap' },
  formAba:          { background:'transparent', border:'1px solid #e5e0ef', borderRadius:20, color:'#5f5874', padding:'6px 16px', fontSize:13, fontWeight:500, cursor:'pointer' },
  formAbaAtiva:     { background:'#7c3aed', border: '1px solid #7c3aed', color:'white' },
  secaoForm:        { background:'#ffffff', border:'1px solid #eeeaf5', borderRadius:10, padding:'1rem', display:'flex', flexDirection:'column', gap:'0.75rem' },
  secaoLabel:       { fontSize:12, fontWeight:700, color:'#7c3aed', textTransform:'uppercase', letterSpacing:'0.08em' },
  formRow:          { display:'flex', gap:'1rem', flexWrap:'wrap' },
  campo:            { display:'flex', flexDirection:'column', gap:5, flex:1, minWidth:160 },
  label:            { fontSize:12, fontWeight:600, color:'#5f5874', textTransform:'uppercase', letterSpacing:'0.04em' },
  input:            { background:'#f7f5fb', border:'1px solid #e5e0ef', borderRadius:8, color:'#1c1530', padding:'8px 12px', fontSize:13, outline:'none', width:'100%', boxSizing:'border-box' },
  formActions:      { display:'flex', gap:'0.75rem', justifyContent:'flex-end', flexWrap:'wrap', paddingTop:'0.5rem', borderTop:'1px solid #eeeaf5' },
  btnPreview:       { display:'flex', alignItems:'center', gap:6, background:'transparent', border:'1px solid #e5e0ef', borderRadius:8, color:'#5f5874', cursor:'pointer', padding:'9px 16px', fontSize:13 },
  btnSalvar:        { background:'#7c3aed', border:'none', borderRadius:8, color:'white', cursor:'pointer', padding:'9px 22px', fontSize:13, fontWeight:600 },
  btnCancelar:      { background:'transparent', border:'1px solid #e5e0ef', borderRadius:8, color:'#5f5874', cursor:'pointer', padding:'9px 16px', fontSize:13 },
  vazio:            { display:'flex', flexDirection:'column', alignItems:'center', gap:'0.75rem', padding:'3rem', color:'#5f5874', fontSize:14 },
  clausulasInfo:    { background:'rgba(124,58,237,0.08)', border:'1px solid rgba(124,58,237,0.2)', borderRadius:8, padding:'0.875rem', fontSize:13, color:'#2d2640', lineHeight:1.5 },
  clausulaCard:     { background:'#ffffff', border:'1px solid #eeeaf5', borderRadius:10, padding:'1rem', display:'flex', flexDirection:'column', gap:'0.25rem' },
  clausulaHeaderRow:{ display:'flex', justifyContent:'space-between', alignItems:'center' },
  checkRow:         { display:'flex', alignItems:'center', gap:'0.75rem', cursor:'pointer', flex:1 },
  clausulaTitulo:   { fontSize:13, fontWeight:700, color:'#1c1530', letterSpacing:'0.04em' },
  inputTitulo:      { background:'#f7f5fb', border:'1px solid #7c3aed', borderRadius:6, color:'#1c1530', padding:'4px 8px', fontSize:13, fontWeight:700, outline:'none', flex:1 },
  clausulaAcoes:    { display:'flex', gap:4, alignItems:'center' },
  btnMover:         { background:'transparent', border:'1px solid #e5e0ef', borderRadius:5, color:'#5f5874', cursor:'pointer', padding:'2px 7px', fontSize:13, lineHeight:1 },
  btnEditCl:        { background:'transparent', border:'none', color:'#8b5cf6', cursor:'pointer', padding:4, display:'flex' },
  btnDelCl:         { background:'transparent', border:'none', color:'#ef4444', cursor:'pointer', padding:4, display:'flex' },
  btnSalvarCl:      { background:'transparent', border:'1px solid #10b981', borderRadius:6, color:'#10b981', cursor:'pointer', padding:'4px 12px', fontSize:12, alignSelf:'flex-end', marginTop:'0.25rem' },
  btnAddClausula:   { display:'flex', alignItems:'center', gap:6, background:'transparent', border:'1px dashed #7c3aed', borderRadius:10, color:'#8b5cf6', cursor:'pointer', padding:'10px 20px', fontSize:13, fontWeight:600, justifyContent:'center' },
  novaClausulaCard: { background:'#ffffff', border:'1px solid #7c3aed', borderRadius:10, padding:'1rem', display:'flex', flexDirection:'column', gap:'0.75rem' },
  propostaCard:     { background:'#ffffff', border:'1px solid #e5e0ef', borderRadius:12, overflow:'hidden' },
  propostaHeader:   { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'1.1rem 1.25rem', cursor:'pointer' },
  propostaInfo:     { display:'flex', flexDirection:'column', gap:3 },
  propostaNome:     { fontSize:15, fontWeight:700, color:'#1c1530' },
  propostaMeta:     { fontSize:12, color:'#5f5874' },
  propostaAcoes:    { display:'flex', alignItems:'center', gap:6, flexWrap:'wrap' },
  badge:            { fontSize:11, fontWeight:700, border:'1.5px solid', borderRadius:20, padding:'2px 10px' },
  btnAcao:          { background:'transparent', border:'none', color:'#5f5874', cursor:'pointer', padding:4, display:'flex' },
  btnAcaoEdit:      { background:'transparent', border:'none', color:'#8b5cf6', cursor:'pointer', padding:4, display:'flex' },
  btnAcaoDel:       { background:'transparent', border:'none', color:'#ef4444', cursor:'pointer', padding:4, display:'flex' },
  propostaDetalhes: { borderTop:'1px solid #eeeaf5', padding:'1.25rem', display:'flex', flexDirection:'column', gap:'0.75rem' },
  detalheLabel:     { fontSize:11, fontWeight:700, color:'#7c3aed', textTransform:'uppercase', letterSpacing:'0.06em' },
  detalheTexto:     { fontSize:13, color:'#2d2640', lineHeight:1.6, whiteSpace:'pre-line' },
  clausulaPill:     { fontSize:11, fontWeight:600, background:'rgba(124,58,237,0.12)', border:'1px solid rgba(124,58,237,0.3)', color:'#8b5cf6', borderRadius:20, padding:'2px 10px' },
  overlay:          { position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'1rem' },
  previewModal:     { background:'#ffffff', border:'1px solid #e5e0ef', borderRadius:14, width:'100%', maxWidth:720, maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' },
  previewHeader:    { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'1.25rem 1.5rem', borderBottom:'1px solid #e5e0ef' },
  previewTitulo:    { color:'#1c1530', fontSize:16, fontWeight:700 },
  btnExportar:      { display:'flex', alignItems:'center', gap:6, background:'#10b981', color:'white', border:'none', borderRadius:8, padding:'7px 14px', fontSize:12, fontWeight:600, cursor:'pointer' },
  modalFechar:      { background:'transparent', border:'none', color:'#5f5874', cursor:'pointer', display:'flex' },
  previewTexto:     { padding:'1.5rem', fontSize:12, color:'#2d2640', lineHeight:1.7, overflowY:'auto', whiteSpace:'pre-wrap', fontFamily:'monospace', background:'#ffffff', flex:1 },
  btnBanco:         { display:'flex', alignItems:'center', gap:6, background:'transparent', border:'1px solid #8b5cf6', borderRadius:20, color:'#8b5cf6', padding:'7px 16px', fontSize:12, fontWeight:600, cursor:'pointer' },
  importBanco:      { background:'rgba(124,58,237,0.05)', border:'1px solid rgba(124,58,237,0.2)', borderRadius:10, padding:'1rem', display:'flex', flexDirection:'column', gap:'0.5rem' },
  catBtn:           { background:'transparent', border:'1px solid #e5e0ef', borderRadius:20, color:'#5f5874', padding:'4px 12px', fontSize:11, fontWeight:600, cursor:'pointer' },
  catBtnAtivo:      { background:'#7c3aed', border: '1px solid #7c3aed', color:'white' },
  importItem:       { display:'flex', alignItems:'flex-start', gap:'0.75rem', padding:'0.6rem 0.75rem', borderRadius:8, border:'1px solid #eeeaf5', cursor:'pointer', background:'#ffffff' },
  importItemSel:    { background:'rgba(124,58,237,0.12)', borderColor:'rgba(124,58,237,0.4)' },
  btnImportar:      { display:'flex', alignItems:'center', gap:6, background:'#7c3aed', border:'none', borderRadius:8, color:'white', padding:'8px 16px', fontSize:12, fontWeight:600, cursor:'pointer', alignSelf:'flex-start', marginTop:'0.25rem' },
};
